export const UPDATE_SIGNUP_STATUS = 'UPDATE_SIGNUP_STATUS';
export const UPDATE_VOUCHER_OBJECT = 'UPDATE_VOUCHER_OBJECT';
